export default class Progress {
    public constructor(
        private readonly progress: number,
        private readonly size: string = '',
        private readonly downloaded: string = '',
        private readonly speed: string = '',
        private readonly time: string = ''
    ) {
    }

    public static from(progress: any): Progress {
        return new Progress(
            progress.progress,
            progress.size,
            progress.downloaded,
            progress.speed,
            progress.time
        );
    }

    public getProgress(): number {
        return this.progress;
    }

    public getSize(): string {
        return this.size;
    }

    public getDownloaded(): string {
        return this.downloaded;
    }

    public getSpeed(): string {
        return this.speed;
    }

    public getTime(): string {
        return this.time;
    }

    public isEmpty(): boolean {
        return this.progress === 0
            && this.size === ''
            && this.downloaded === ''
            && this.speed === ''
            && this.time === '';
    }
}